function scriptsCard(productCard, color, cod) {
    const colorSelector = productCard.querySelector('.color-selector');
    if (colorSelector?.childElementCount > 0) {
        return
    }
    //console.log('chamouu');
    const sizeSelector = productCard.querySelector('.size-selector');
    const productImage = productCard.querySelector('.product-image');
    const productImageHover = productCard.querySelector('.product-image.hover');
    const productPriceList = productCard.querySelector('.price .list');
    const productPriceBest = productCard.querySelector('.price .best');
    const productInstallments = productCard.querySelector('.installments');
    const variationMessage = productCard.querySelectorAll('.variation-message');
    const addCart = productCard.querySelector('.buy');

    const productLink = productCard.getAttribute('data-product-handle');

    var quickViewSizes = document.querySelector('.selectorMob .sizes');
    const quickView = productCard.querySelector('#buy_mobile');

    let currentId = null;
    let selectedColor = null;
    let selectedSize = null;

    const colorInitial = color;

    const codProd = cod;

    const query = `
  query ProductsByMetafield {
    collection(handle: "homepage") {
      handle
      products(
        first: 100,
        filters: {
          productMetafield: {
            namespace: "custom",
            key: "grupo_de_produto",
            value: "${codProd}"
          }
        }
      ) {
        edges {
          node {
            handle
            title
            images(first: 2) {
              edges {
                node {
                  originalSrc
                  altText
                }
              }
            }
            variants(first: 20) {
              edges {
                node {
                  id
                  availableForSale
                  priceV2 {
                    amount
                    currencyCode
                  }
                  compareAtPriceV2 {
                    amount
                    currencyCode
                  }
                  image {
                    originalSrc
                  }
                  selectedOptions {
                    name
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;


    async function fetchProducts() {
        const response = await fetch('/api/2023-07/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': '1e873c046e6e9268dcfc76eaeb258d14',
            },
            body: JSON.stringify({ query }),
        });

        const result = await response.json();
        return result.data?.collection?.products.edges;
    }

    async function updateSelectors() {
        const products = await fetchProducts();

        if (!products) {
            return
        }

        // Limpar o conteúdo anterior dos seletores
        colorSelector.innerHTML = '';
        sizeSelector.innerHTML = '';

        if (products.length === 0) {
            return; // Caso não haja produtos, não exibe nada
        }

        // Iniciar com a primeira cor do produto
        selectedColor = colorInitial || '';        

        // Usar apenas os 2 primeiros produtos como cores
        products.slice(0, innerWidth < 1024 ? 4 : 20).forEach(({ node: product }) => {
            const color = product.variants.edges[0].node.selectedOptions.find(option => option.name === "Cor")?.value || 'Sem cor';
            const hexa = `https://cdn.shopify.com/s/files/1/0918/1544/4754/files/cor-${stringToSlug(color)}.png`;
            const imageUrl = product.images?.edges[0]?.node?.originalSrc || product.featured_image?.src;
            const imageUrlHover = product.images?.edges[1]?.node?.originalSrc || product.featured_image?.src;
            const list_price = product.variants.edges[0].node.compareAtPriceV2?.amount;
            const best_price = product.variants.edges[0].node.priceV2.amount;
            const link = '/products/'+product.handle


            colorSelector.innerHTML += `
          <span class="color-option" title="${color}" data-bestprice="${best_price}" data-listprice="${list_price ?? '0.0'}" data-color="${color}" data-image="${imageUrl}" data-imagehover="${imageUrlHover}" data-link="${link}">
            <img src="${hexa}" alt="${color}" />
          </span>`;

            // Se for a primeira cor, seleciona por padrão
            if (!selectedColor) {
                // selectedColor = color;
                // productImage.src = imageUrl;
            }

            // Adicionar os tamanhos disponíveis para cada cor
            product.variants.edges.forEach(({ node: variant }) => {                
                const size = variant.selectedOptions.find(option => option.name === "Tamanho")?.value;
                const priceList = variant.compareAtPriceV2?.amount;
                const priceBest = variant.priceV2?.amount;
                const variantId = variant.id.split('ProductVariant/')[1];
                if (size) {
                    sizeSelector.innerHTML += `
                    <button class="size-option" data-bestprice="${priceBest}" data-listprice="${priceList ?? '0.0'}" data-color="${color}" data-size="${size}" data-id="${variantId}" ${!variant.availableForSale ? 'disabled' : ''
                        }>
                    ${size}
                    </button>`;
                }
            });
        });

        if (products?.length > 4 && innerWidth < 1024) {
            colorSelector.innerHTML += '<a style="font-size: 11px;white-space: nowrap;" href="/products/' + productLink + '">+ Cores</a>'
        }

        // Selecionar a cor inicial e tamanhos relacionados
        colorSelector.querySelector(`[data-color="${selectedColor}"]`)?.classList.add('selected');
        filterSizeOptionsByColor(selectedColor);

        addEventListeners();
    }

    function addEventListeners() {
        const colorOptions = productCard.querySelectorAll('.color-option');
        const sizeOptions = productCard.querySelectorAll('.size-option');

        colorOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                event.preventDefault();
                //console.log('cliquei na cor', option.dataset);

                selectedColor = option.dataset.color;
                const imageUrl = option.dataset.image;
                const imageUrlHover = option.dataset.imagehover;
                const priceBest = option.dataset.bestprice;
                const pricelist = option.dataset.listprice;
                const link = option.dataset.link;

                productCard.querySelector('.product-image-wrapper .images').href = link

                const installments = 10;
                //const installmentValue = (Number(priceBest) / installments).toFixed(3);
                const installmentValue = Math.trunc((priceBest / installments) * 100) / 100;

                //console.log('installmentValue', installmentValue);


                const formattedInstallment = installmentValue.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                });

                // Atualizar a imagem do produto
                productImage.src = imageUrl;
                productImageHover.src = imageUrlHover;

                // Atualizar Precos            

                if (pricelist == '0.0' && productPriceList) {
                    productPriceList.style.display = 'none';
                }
                else if (productPriceList) {
                    productPriceList.style.display = 'block';
                }


                productPriceBest.innerHTML = Number(priceBest).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                });

                if (productPriceList) {
                    productPriceList.innerHTML = Number(pricelist).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    });
                }


                productInstallments.innerHTML = `${installments}x de <b>${formattedInstallment}</b> sem juros`;

                // Marcar a cor selecionada
                colorOptions.forEach((el) => el.classList.remove('selected'));
                option.classList.add('selected');

                // Mostrar apenas os tamanhos disponíveis para a cor selecionada
                filterSizeOptionsByColor(selectedColor);
                variationMessage.forEach((element) => {
                    element.style.display = 'none';
                });
            });
        });

        sizeOptions.forEach((option) => {
            option.addEventListener('click', () => {
                sizeOptions.forEach((el) => el.classList.remove('selected'));
                option.classList.add('selected');
                selectedSize = option.dataset.size;
                currentId = option.dataset.id;
                const priceBest = option.dataset.bestprice;
                const pricelist = option.dataset.listprice;

                variationMessage.forEach((element) => {
                    element.style.display = 'none';
                });

                if (pricelist == '0.0') {
                    productPriceList.style.display = 'none';
                }
                else {
                    productPriceList.style.display = 'block';
                }

                productPriceBest.innerHTML = Number(priceBest).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                });
                productPriceList.innerHTML = Number(pricelist).toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                });
            });
        });
    }

    function filterSizeOptionsByColor(selectedColor) {
        const sizeOptions = productCard.querySelectorAll('.size-option');
        sizeOptions.forEach((size) => {
            if (size.dataset.color === selectedColor) {
                size.style.display = 'inline-block';
            } else {
                size.style.display = 'none';
            }
        });
    }

    updateSelectors();

    addCart.addEventListener('click', () => {
        // console.log('currentId', currentId);
        // console.log('selectedColor', selectedColor);
        // console.log('selectedSize', selectedSize);
        if (!currentId) {
            variationMessage.forEach((element) => {
                element.style.display = 'flex';
            });
            return;
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                id: currentId,
                quantity: 1,
                properties: {
                    Cor: selectedColor,
                    Tamanho: selectedSize,
                },
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                console.log('Item adicionado ao carrinho:', data);
                openMiniCart();
            })
            .catch((error) => {
                console.error('Erro ao adicionar ao carrinho:', error);
            });
    });

    //quickView
    // quickView.addEventListener('click', () => {
    //     var listSizes = productCard.querySelectorAll('.size-option');
    //     quickViewSizes.innerHTML = '';
    //     if (listSizes) {
    //         listSizes.forEach((size) => {
    //             let variantId = size.getAttribute('data-id');
    //             let color = size.getAttribute('data-color');
    //             let sizeValue = size.textContent.trim(); // Obtém o tamanho

    //             let button = document.createElement('button');
    //             button.setAttribute('data-variant-id', variantId);
    //             button.setAttribute('data-color', color);
    //             button.setAttribute('data-size', sizeValue);
    //             button.textContent = sizeValue;

    //             // console.log('selectedColor', selectedColor);
    //             // console.log('color', color);

    //             button.addEventListener('click', function () {
    //                 quickViewSizes.querySelectorAll('button').forEach((btn) => btn.classList.remove('active'));
    //                 this.classList.add('active');
    //             });

    //             if (selectedColor == color) {
    //                 quickViewSizes.appendChild(button);
    //             }
    //         });
    //     }

    //     document.querySelector('.selectorMob').classList.add('open');
    // });
}